import { Link, NavLink, useLocation } from "react-router-dom";
import { useAppSelector } from "../../../../../redux/store";
import Logo from "../../../../assets/appImage/MaajjalAdminlogo.png";
import VersionChecker from "../../../../utils/VersionChecker";
import { isAccessGranted } from "../../../Modals/Administrateur/ModifierAdministrateurModal";
import { Routes } from "../AdminRoutes/AminRoutes";
import "./SideBarAdmin.css";

// L'entree active se deduit de l'URL, pas d'un index passe par chaque page :
// seize pages codaient le leur en dur, si bien qu'inserer une entree au milieu
// du menu les decalait toutes. On retient le chemin le plus long qui prefixe
// l'URL, pour qu'une page de detail reste rattachee a sa rubrique.
export function useActiveLink(links: { pathname?: string }[], fallback: number) {
  const { pathname } = useLocation();
  let actif = -1;
  links.forEach((link, i) => {
    const chemin = link?.pathname;
    if (!chemin || chemin === "#") return;
    if (pathname === chemin || pathname.startsWith(chemin + "/")) {
      if (actif < 0 || chemin.length > (links[actif].pathname || "").length) {
        actif = i;
      }
    }
  });
  return actif >= 0 ? actif : fallback;
}

interface PropsType {
  index: number;
}

const SideBarAdmin = ({ index }: PropsType) => {
  const user = useAppSelector((s) => s.user.user);
  const links = Routes;
  const active = useActiveLink(links, index);
  return (
    <div id="scrollbar-nav" className="sidebar-admin no-view-md">
      <div className="logo-container flex-cc pt-4">
        <NavLink to="/">
          <img src={Logo} alt="logo" />
        </NavLink>
        <div className="version-viewer-container admin-desktop-side">
          {"v" + VersionChecker()}
        </div>
      </div>

      <div className="content-nav">
        <ul className="sidebar-admin-links mt-4 px-3">
          {links.map((link, index) => {
            if (!isAccessGranted(user, link.permission)) return null;

            return (
              <li
                className={`${active === index && "active-admin-item"}`}
                key={index}
              >
                <Link
                  to={link.pathname}
                  className={`sidebar-admin-link  ${
                    active === index && "active-admin-link"
                  }`}
                >
                  <span className="sidebar-icon-container">{link.icon}</span>
                  {link.label}
                </Link>
              </li>
            );
          })}
        </ul>
      </div>
    </div>
  );
};

export default SideBarAdmin;
